import { Typography } from "@sunday/component";
import styled from "styled-components";

export const TermsPageContainer = styled.main`
  --color-text-ci: var(--colors-system-primitive-color-ic-blueneon-50, #435dff);
  --typography-bg-color-selection: var(--color-text-ci);
  --typography-color-selection: var(--color-text-on-primary, #ffffff);
  --typescale-font-head: var(--typeface-font-ic-en, "JUST Sans"),
    var(--typeface-font-ic-th, "Noto Sans Thai"), sans-serif;
  --typescale-font-base: var(--typeface-font-ic-th, "Noto Sans Thai"),
    var(--typeface-font-ic-en, "JUST Sans"), sans-serif;

  background: var(--color-surface-primary, #ffffff);

  && *::selection {
    background-color: var(--typography-bg-color-selection) !important;
    color: var(--typography-color-selection) !important;
  }
`;

export const TermsContentContainer = styled.div`
  width: 100%;
  max-width: 1388px;
  margin: 0 auto;
  padding: 80px 0;

  @media (max-width: 767px) {
    padding: 40px 16px 120px;
  }
`;

export const TermsContent = styled.div`
  width: 100%;
  max-width: 803px;
  margin: 0 auto;
`;

export const TermsTitle = styled(Typography.Display).attrs({
  designLevel: 3,
  weight: "bold",
  level: 1,
})`
  && {
    display: block;
    margin: 0 0 24px;
    color: var(--color-text-primary, #202123);
    word-break: break-word;
  }

  @media (max-width: 767px) {
    && {
      --typography-d3-font-size: var(--typescale-size-h-1, 28px);
      --typography-d3-line-height: var(--typescale-line-height-h-1, 36px);
    }
  }
`;

export const TermsArticle = styled.article`
  --typography-color: var(--color-text-secondary, #5f6468);

  color: var(--color-text-secondary, #5f6468);
  word-break: break-word;
`;

export const TermsHeading = styled.h2`
  margin: 0;
`;

export const TermsSectionTitle = styled(Typography.Body).attrs({
  designLevel: 2,
  weight: "bold",
})`
  && {
    display: block;
    color: inherit;
  }
`;

export const TermsParagraph = styled.p`
  margin: 0;
`;

export const TermsBodyText = styled(Typography.Body).attrs({
  designLevel: 2,
  weight: "regular",
})`
  && {
    display: block;
    color: inherit;
  }
`;

export const TermsSpacer = styled.div`
  height: var(--typescale-line-height-b-2, 24px);
`;
